import { useTheme } from '../context/ThemeContext'

export const useIsDark = () => {
	const { theme } = useTheme()
	return theme === 'dark'
}
